import {
  deleteMonster,
  getMonsters,
  getSingle,
  putMonster,
} from "@/common/adventure/monsterNpc";
import adventure from "../adventure";

export interface monstersState {
  monsters: Array<monsterInterface>;
  npcs: Array<monsterInterface>;
  tabbedMonsters: Array<number>;
  page: number;
  currentMonster: number;
  currentMonsterObject: any;
}

export interface monsterInterface {
  id: number;
  image: string;
  name: string;
  currentHp: number;
  hp: number;
  mana: number;
  currentMana: number;
  mp: number;
  description: string;
  location: string;
  armorDvs: number;
  shieldDvs: number;
  moveDvs: number;
  bonusDvs: number;
  agility: number;
  charisma: number;
  health: number;
  intelligence: number;
  perception: number;
  power: number;
  strength: number;
  willpower: number;
  exceptionalAgility: number;
  exceptionalCharisma: number;
  exceptionalHealth: number;
  exceptionalIntelligence: number;
  exceptionalPerception: number;
  exceptionalPower: number;
  exceptionalStrength: number;
  exceptionalWillpower: number;
  isMonster: boolean;
  spellsId: number;
  martialPerksId: number;
  WeaponSkillsId: number;
  skillsId: number;
  traitsId: number;
  adventureId: number;
  npcMartialPerks: Array<npcMartialPerks>;
  npcSkills: Array<npcSkills>;
  npcSpells: Array<npcSpells>;
  npcTraits: Array<npcTraits>;
  npcWeaponSkills: Array<npcWeaponSkills>;
}
export interface npcSkills {
  rank: string;
  name: string;
  description: string;
}

export interface npcSpells {
  rank: string;
  name: string;
  description: string;
}

export interface npcTraits {
  trait: string;
}
export interface npcWeaponSkills {
  rank: string;
  name: string;
  description: string;
}

export interface npcMartialPerks {
  rank: string;
  name: string;
  description: string;
}

export default {
  strict: true,
  namespaced: true,
  state: (): monstersState => ({
    currentMonster: 0,
    monsters: [],
    npcs: [],
    tabbedMonsters: [],
    page: 0,
    currentMonsterObject: {},
  }),
  getters: {
    monsters: (state: monstersState) => {
      return state.monsters;
    },
    currentMonster: (state: monstersState) => {
      return state.currentMonster;
    },
    tabbedMonsters: (state: monstersState) => {
      return state.tabbedMonsters;
    },
    page: (state: monstersState) => {
      return state.page;
    },
  },
  mutations: {
    setMonsters: (state: monstersState, newData: Array<monsterInterface>) => {
      state.monsters = newData;
    },
    setCurrentMonster: (state: monstersState, newData: number) => {
      state.currentMonster = newData;
    },
    setCurrentMonsterObject: (
      state: monstersState,
      newData: monsterInterface
    ) => {
      console.log(newData);
      state.currentMonsterObject = newData;
    },
    addTabbedMonster: (state: monstersState, id: number) => {
      if (!state.tabbedMonsters.includes(id)) {
        state.tabbedMonsters.push(id);
      }
    },
    unTabMonster: (state: monstersState, id: number) => {
      for (let i = 0; i < state.tabbedMonsters.length; i++) {
        if (state.tabbedMonsters[i] === id) {
          state.tabbedMonsters.splice(i, 1);
          break;
        }
      }
    },
    setPage: (state: monstersState, page: number) => {
      state.page = page;
    },
    setMonster: (state: monstersState, newData: monsterInterface) => {
      const id = newData.id;
      let found = false;
      for (let i = 0; i < state.monsters.length; i++) {
        if (state.monsters[i].id === id) {
          found = true;
          state.monsters[i] = newData;
          break;
        }
      }
      if (!found) {
        state.monsters.push(newData);
      }
    },
    removeMonster: (state: monstersState, newData: monsterInterface) => {
      const id = newData.id;
      for (let i = 0; i < state.monsters.length; i++) {
        if (state.monsters[i].id === id) {
          state.monsters.splice(i, 1);
          break;
        }
      }
    },
    setNumericalMonsterPropertyById: (
      state: monstersState,
      newData: { monsterId: number; value: number; propertyName: string }
    ) => {
      for (let i = 0; i < state.monsters.length; i++) {
        if (state.monsters[i].id === newData.monsterId) {
          const monster = state.monsters[i];
          (monster as any)[newData.propertyName] = newData.value;
        }
      }
    },
    addNewMonsterNPC: (state: monstersState, newMonster: monsterInterface) => {
      if (newMonster.isMonster) {
        state.monsters.unshift(newMonster);
      } else {
        state.npcs.unshift(newMonster);
      }
    },
    addMonsterToAdventure: (
      state: monstersState,
      newData: monsterInterface
    ) => {
      state.monsters.push(newData);
    },
    editMonsterInAdventure: (
      state: monstersState,
      newData: monsterInterface
    ) => {
      for (let i = 0; i < state.monsters.length; i++) {
        if (state.monsters[i].id === newData.id) {
          state.monsters.splice(i, 1, newData);
        }
      }
    },
  },
  actions: {
    addFromExsisting: (
      context: any,
      newData: { id: number; adventureId: number }
    ) => {
      getSingle(newData.id).then((response) => {
        const monster = response.data;
        monster.id = 0;
        monster.adventureId = newData.adventureId;
        context.dispatch("addNewMonsterNpc", response.data);
      });
    },
    toggleTabbedMonster: (context: any, id: number) => {
      if (context.getters.tabbedMonsters.includes(id)) {
        context.commit("unTabMonster", id);
      } else {
        context.commit("addTabbedMonster", id);
      }
    },
    getMonsters: (context: any, adventureId: number) => {
      getMonsters(adventureId).then((response) =>
        context.commit("setMonsters", response.data)
      );
    },
    addNewMonsterNpc: (context: any, newData: monsterInterface) => {
      putMonster(newData).then((response) => {
        newData.id = response.data[0].id;
        context.commit("addNewMonsterNpc", newData);
      });
    },
    setMonsterDb: (context: any, newData: monsterInterface) => {
      putMonster(newData).then((response) => {
        context.commit("setMonster", response.data[0]);
        context.commit("setCurrentMonsterObject", response.data[0]);
      });
    },
    removeMonsterDb: (context: any, newData: monsterInterface) => {
      context.commit("removeMonster", newData);
      deleteMonster(newData);
    },
  },
};
